import React, { ReactNode } from 'react'

interface HeaderProps {
  title: string
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <div className="class_header">
      <h5 className="title">{title}</h5>
    </div>
  )
}

interface ExtraContentProps {
  content: ReactNode
}

export const ExtraHeaderContent: React.FC<ExtraContentProps> = ({ content }) => {
  return content ? (
    <div
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      {content}
    </div>
  ) : null
}
